import React from 'react';

import { Container } from 'react-bootstrap';

function Contact() {

    return (
        <>
        <Container>
            <h1 className='text-center'>Contact</h1>
            <p>Contact details and maybe contact email form go here</p>
        </Container>
        </>
    );
};

export default Contact;